import Filter from './Filter';
import type {QueryGeometryType, QueryType} from "../../types";
import type {RelationType} from "../../types-analytics";

export default class FilterLastUsed extends Filter {

    private historyOfAddedKeys: string[] = [];

    constructor() {
        super();
        this.historyOfAddedKeys = [];
    }

    getHistoryOfAddedKeys(): string[] {
        return this.historyOfAddedKeys;
    }

    setHistoryOfAddedKeys(keys: string[]): void {
        this.historyOfAddedKeys = keys;
    }

    addHistoryKey(key: string): void {
        // // get short name of key for GEOM/RADIUS and GEOM/AREA
        // // https://er.automapa.pl/issues/34878
        // if (key.includes('/')) {
        //     const keyParts = key.split('/');
        //     key = keyParts[0];
        // }

        // if (key === 'geom') {
        //     console.warn('Ignoring `geom` due to not supported yet in last used filter');
        //     return;
        // }

        // Remove duplicates
        // https://er.automapa.pl/issues/34875
        this.historyOfAddedKeys = this.historyOfAddedKeys.filter((item) => item !== key);

        this.historyOfAddedKeys.push(key);
    }

    updateFilterItem(key: string, mongoCondition: QueryType | QueryGeometryType): string {
        this.addHistoryKey(key);
        super.updateFilterItem(key, mongoCondition);
        return key;
    }

    updateFilterRelatedItem(key: string, fields: RelationType): void {
        this.addHistoryKey(key);
        super.updateFilterRelatedItem(key, fields);
    }

    getMenuLabelKeys(maxItems: number): string[] {

        let itemKeysInThisCategory = this.getHistoryOfAddedKeys();

        // Reverse the order of items
        itemKeysInThisCategory = itemKeysInThisCategory.reverse();

        // Get only 5 first items
        itemKeysInThisCategory = itemKeysInThisCategory.slice(0, maxItems);

        return itemKeysInThisCategory;
    }

}
